export default "__VITE_ASSET__lGmpVxWy__"